import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppletContainerModel } from '../../../../../models/aggregates/applet/applet-container.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, ApiVisa, Pagination, PagingResponseModel } from '../shared';


// core2/platform/dm/applets/applets/tenant-admin-ep/{tenantCode}

@Injectable({ providedIn: 'root' })
export class AppletTenantAdminEPService extends BaseApiTemplateService<AppletContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      'applets/tenant-admin-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/tenant-admin-ep';
    this.httpClient = http;
  }

  getAllByTenantCode(tenantCode: string, visa: ApiVisa): Observable<ApiResponseModel<AppletContainerModel>> {
    let url = `${this.apiUrl}/${tenantCode}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${tenantCode}`;
    }
    return this.httpClient.get<ApiResponseModel<AppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );

  }

  // /core2/platform/dm/applets/applets/tenant-admin-ep/{tenantCode}/{guid}
  getByGuidByTenantCode(tenantCode: string, guid: string, visa: ApiVisa): Observable<ApiResponseModel<AppletContainerModel>> {
    let url = `${this.apiUrl}/${tenantCode}/${guid}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${tenantCode}/${guid}`;
    }
    return this.httpClient.get<ApiResponseModel<AppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );

  }

  // /core2/platform/dm/applets/applets/tenant-admin-ep/{tenantCode}/query
  getByCritreriaByTenantCode(tenantCode: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<AppletContainerModel>> {
    const queryParams = pagination.getQueryKeyValues();
    let url = `${this.apiUrl}/${tenantCode}/query?${queryParams}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${tenantCode}/query?${queryParams}`;
    }
    return this.httpClient.get<PagingResponseModel<AppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }


  // /core2/platform/dm/applets/applets/linked-to-tenant/tenant-admin-ep/{tenantCode}/query
  getByCritreriaCustom(tenantCode: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<AppletContainerModel>> {
    const queryParams = pagination.getQueryKeyValues();
    let url = `${Core2Config.DOMAIN_URL}${Core2Config.PLATFORM_DOMAIN_URL_PREFIX}applets/linked-to-tenant/tenant-admin-ep/${tenantCode}/query?${queryParams}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${Core2Config.PLATFORM_DOMAIN_URL_PREFIX}applets/linked-to-tenant/tenant-admin-ep/${tenantCode}/query?${queryParams}`;
    }
    return this.httpClient.get<PagingResponseModel<AppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

}
